<div class="date-filer flex-start-center">
    <!-- dashboard date -->
    <div class="calendar-wrapper flex-start-center mr-3">
        <i class="fal fa-chevron-left font-gray pointer" (click)="handleNavigation('previous')"></i>

        <div class="flex-center-center date-filter-inner pointer" (click)="openDatePicker()">

            <p-calendar class="p-calendar" [(ngModel)]="selectedDateTime" dateFormat="MM dd, yy" [minDate]="minimumDate" styleClass="calendar-date-picker" [style]="{ width: '70%' }" (onSelect)="onSelectDate($event,'custom', 'Custom')">
            </p-calendar>
            <i class="fal fa-calendar-alt pl-1 mr-2 pointer"></i>
            <span class="title">{{ title }}</span>
        </div>

        <i class="fal fa-chevron-right font-gray" (click)="handleNavigation('next')"></i>

        <div class="tech-weekly m-left-15" *ngIf="isTechApp" (click)="changePeriod('week')">
            <div class="week-btn pointer"> This week </div>
        </div>
    </div>
    <!-- dashboard date -->

    <div class="day-week-wrapper" *ngIf="isPeriodSelectionVisible && !makretingDashboard">
        <div [ngClass]="{'active': period === 'day'}" class="carousel-calendar-day" (click)="changePeriod('day', 'today', 'Today')">
            Day
        </div>
        <div [ngClass]="{'active': period === 'week'}" class="carousel-calendar-week" (click)="changePeriod('week','this-week', 'This week')">
            Week
        </div>
        <div [ngClass]="{'active': period === 'month'}" class="carousel-calendar-month" (click)="changePeriod('month', 'this.month', 'This month')">
            Month
        </div>
    </div>

    <div class="day-week-wrapper" *ngIf="makretingDashboard">
        <div [ngClass]="{'active': period === 'month'}" class="carousel-calendar-month font-700" (click)="changePeriod('month', 'this.month', 'This month')">
            Monthly
        </div>
        <div [ngClass]="{'active': period === 'year'}" class="carousel-calendar-month font-700" (click)="changePeriod('year', 'this.year', 'This year')">
            Yearly
        </div>
    </div>
</div>
